var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 2.55385C0.668629 2.55385 0.4 2.82248 0.4 3.15385C0.4 3.48522 0.668629 3.75385 1 3.75385V2.55385ZM13 3.75385C13.3314 3.75385 13.6 3.48522 13.6 3.15385C13.6 2.82248 13.3314 2.55385 13 2.55385V3.75385ZM1 3.75385H2.09091V2.55385H1V3.75385ZM1.49091 3.15385V14H2.69091V3.15385H1.49091ZM3.09091 15.6H10.9091V14.4H3.09091V15.6ZM11.9091 3.75385H13V2.55385H11.9091V3.75385ZM12.5091 14V3.15385H11.3091V14H12.5091ZM2.09091 3.75385H4.81818V2.55385H2.09091V3.75385ZM5.41818 3.15385V2H4.21818V3.15385H5.41818ZM5.81818 1.6H8.18182V0.4H5.81818V1.6ZM4.81818 3.75385H9.18182V2.55385H4.81818V3.75385ZM9.18182 3.75385H11.9091V2.55385H9.18182V3.75385ZM8.58182 2V3.15385H9.78182V2H8.58182ZM4.76364 5.84615V12.3077H5.96364V5.84615H4.76364ZM9.23636 12.3077V5.84615H8.03636V12.3077H9.23636ZM5.41818 2C5.41818 1.77909 5.59727 1.6 5.81818 1.6V0.4C4.93453 0.4 4.21818 1.11634 4.21818 2H5.41818ZM10.9091 15.6C11.7927 15.6 12.5091 14.8837 12.5091 14H11.3091C11.3091 14.2209 11.13 14.4 10.9091 14.4V15.6ZM8.18182 1.6C8.40273 1.6 8.58182 1.77909 8.58182 2H9.78182C9.78182 1.11634 9.06547 0.4 8.18182 0.4V1.6ZM1.49091 14C1.49091 14.8837 2.20725 15.6 3.09091 15.6V14.4C2.86999 14.4 2.69091 14.2209 2.69091 14H1.49091Z",
    fill: "#2F9CEB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBin);
export default __webpack_public_path__ + "static/media/Bin.07aa3a1d018e6eefcafe22c46b835cf0.svg";
export { ForwardRef as ReactComponent };